'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

const UrlRedirect = () => {
  const router = useRouter();
  const pathname = typeof window !== 'undefined' ? window.location.pathname : null;

  useEffect(() => {
    let targetPath = pathname;

    if (!targetPath) {
      return;
    }

    if (targetPath.endsWith('/index.html')) {
      targetPath = targetPath.replace('/index.html', '/');
    }

    const isFile = targetPath.includes('.');

    if (targetPath.length > 1 && !targetPath.endsWith('/') && !isFile) {
      targetPath = `${targetPath}/`;
    }

    if (targetPath !== pathname) {
      router.replace(targetPath);
    }
  }, [pathname, router]);

  return null;
};

export default UrlRedirect;
